import { DeletionRequest } from './versionTypes';
import { useDeletionJob } from './useDeletionJob';
import { deletionStatusLabels } from './versionCopy';
export function DeletionJobStatus({ request }: { request: DeletionRequest }) {
  const query = useDeletionJob(request);
  const job = query.isSuccess ? query.data : undefined;
  return (
    <div aria-label="Ход удаления">
      {query.isPending && <p role="status">Проверка удаления…</p>}
      {query.isError && <p role="alert">Состояние удаления не подтверждено. Это не означает, что запрос отсутствует или выполнен. Обновите состояние; если ошибка сохраняется, обратитесь к оператору.</p>}
      <button className="workspace-secondary-button" type="button" disabled={query.isFetching} onClick={() => { void query.refetch(); }}>Обновить удаление</button>
      {job && (
        <>
          <p role="status">{deletionStatusLabels[job.status]}</p>
          <p>Удалено файлов: {job.completed} · Обработано групп: {job.batches}</p>
          {job.status === 'recovery_required' && <p role="alert">Не продолжайте удаление самостоятельно. Оператор должен проверить результат и состояние карты. Автоматического восстановления нет.</p>}
          {job.status === 'failed' && <p role="alert">Перед новым запросом нужно заново проверить защиту версии и подтвердить удаление. Продолжение частичного удаления здесь недоступно.</p>}
        </>
      )}
    </div>
  );
}
